// src/components/sections/ContactSection.js
import React from 'react';
import { Mail } from 'lucide-react'; // Import necessary icons

function ContactSection({ email }) {
  return (
    <section id="contact" className="py-20 bg-gray-100 scroll-mt-16">
      <div className="container mx-auto px-6 text-center max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Get in Touch</h2>
        <p className="text-lg text-gray-700 mb-8">
          Ready to leverage your data for growth? Contact us today to discuss your needs.
        </p>
        {/* Only render link if email is provided */}
        {email && (
          <a
            href={`mailto:${email}`}
            className="inline-flex items-center bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300 ease-in-out transform hover:scale-105"
          >
            <Mail size={20} className="mr-2" /> Contact Us
          </a>
        )}
      </div>
    </section>
  );
}

export default ContactSection;
